import type { FormOptions } from '@customTypes/types';

export const supportIssueDetailsOptions: FormOptions = {
  developerPortal: 'Developer Portal',
  api: 'API',
  // partnerApi: 'Partner API',
  other: 'Other',
};

export const developerPortalIssuesOptions: FormOptions = {
  searchAndNavigation: 'Search and navigation',
  apiTocken: 'API Token',
  tryIt: 'Try it',
  other: 'Other',
};

export const apiIssuesOptions: FormOptions = {
  auditLogs: 'Audit logs',
  authorization: 'Authorization',
  computeOpsManagement: 'Compute Ops Management',
  // dataServices: 'Data Services',
  devices: 'Devices',
  // hpeGreenLake: 'HPE GreenLake',
  // hpeGreenLakeFlex: 'HPE GreenLake Flex Solutions',
  identity: 'Identity',
  locationManServ: 'Location Management Services',
  subscriptions: 'Subscriptions',
  sustainInsightCenter: 'Sustainability Insight Center',
  wellness: 'Wellness',
  workspace: 'Workspace',
};

export const partnerApiIssuesOptions: FormOptions = {
  partnerBilling: 'Partner Billing API'
}
